export enum RmaOrderStatusEnum {
    Issued = 0,
    Received = 1,
}

export enum RmaOrderItemSolutionEnum {
    Refund = 0,
    Replace = 1,
}